<script setup lang="ts">
import { useCommonCodeStore } from '~/store/commonCodeStore';


const commonCodeStore = useCommonCodeStore();

const props = defineProps<{
  eqStatus: string;
}>()

</script>

<template>
  <div class="simple-equip-status">
    <div class="common-label on" v-if="props.eqStatus === 'on'">
      켜짐
    </div>
    <div class="common-label off" v-else-if="props.eqStatus === 'off'">
      꺼짐
    </div>
    <div v-else :class="`common-label ${props.eqStatus}`">
      {{ commonCodeStore.getMapCode('opStatus', props.eqStatus)?.codeName }}
    </div>
  </div>  
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-label.scss";
.common-label {
  font-size: 10px;
  line-height: 10px;
  padding: 4px 14px;

  @media (max-width: 768px) {
    font-size: 8px;
    line-height: 8px;
    padding: 2px 10px;
  }

  &.normal,
  &.success,
  &.on {
    background: #bcf2cb;
    color: #07942f;
  }
}
</style>